import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';


@Component({
  selector: 'app-mini-cart-pop-up',
  templateUrl: './mini-cart-pop-up.component.html',
  styleUrls: ['./mini-cart-pop-up.component.scss'],
  standalone: false
})
export class MiniCartPopUpComponent implements OnInit {
  cartProdData$: Observable<any>;
  fleetPrideGroup: any;
  showNetPrice$: BehaviorSubject<any>;
  subscription = new Subscription();
  constructor(public activeCart: ActiveCartFacade,
    private custIDService: CustomerIdService, private cdr: ChangeDetectorRef,

  ) { }
  ngOnInit() {
    this.activeCart.reloadActiveCart();
    this.showNetPrice$ = this.custIDService.showNetPrice$;
    this.cartProdData$ = this.activeCart.getEntries();
    this.subscription.add(this.custIDService.fleetPrideGroup$.subscribe(x => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    }));
  }


  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
